export const ADD_FAVORITE_TOGGLE = 'ADD_FAVORITE_TOGGLE';
export const FAVORITES_FORM = 'favoritesSearch';
export const FAVORITES_FORM_FOCUSED = 'FAVORITES_FORM_FOCUSED';
